<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="IMEI" v-model="imei" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-select v-model="topicType" placeholder="下发类型" clearable style="width: 100%">
          <el-option label="SYNC" value="SYNC"></el-option>
          <el-option label="S/SET" value="S/SET"></el-option>
          <el-option label="S/SOUND" value="S/SOUND"></el-option>
          <el-option label="S/OTA" value="S/OTA"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="status" placeholder="下发状态" clearable style="width: 100%">
          <el-option label="成功" :value="1"></el-option>
          <el-option label="失败" :value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 100%"
          clearable
        >
        </el-date-picker>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="data"
      border
      row-key="id"
      stripe
      style="width: 100%"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="device_id" label="设备编号" >
      </el-table-column>
      <el-table-column prop="imei" label="IMEI" >
      </el-table-column>
      <el-table-column prop="topic_type" label="下发类型" >
      </el-table-column>
      <el-table-column prop="id" label="序列号" >
      </el-table-column>
      <el-table-column prop="json_data" label="下发内容" >
      </el-table-column>
      <el-table-column prop="status" label="下发状态" >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '成功' : '失败' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" >
      </el-table-column>
      <el-table-column prop="down_time" label="下发时间">
      </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      deviceId: "",
      imei: "",
      topicType: "",
      status: null,
      dateRange: [],
      data: [],
      env: this.getEnv(),
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.relevancePagin.pageNum = val;
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        topicType: this.topicType,
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      if (this.imei.trim() != "") {
        params.imei = this.imei;
      }
      // if (this.topicType) {
      //   params.topicType = this.topicType;
      // }
      if (this.status !== null && this.status !== undefined) {
        params.status = this.status;
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = this.dateRange[1];
      }
      this.$http
        .post(`${this.env}/manage/serviceTopicDataDownload/list`, params)
        .then((results) => {
          const records = results["data"]["data"]["records"];
          // 解析 json_data 字段
          this.data = records.map(item => {
            let jsonData = [];
            try {
              jsonData = JSON.parse(item.json_data || '[]');
            } catch (e) {
              console.error('解析 json_data 失败:', e);
            }
            return {
              ...item,
              content: Array.isArray(jsonData) && jsonData.length > 1 ? jsonData[1] : '',
            };
          });
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },

  },
  components: { Pagination },
};
</script>
  
  <style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>